// import { useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { CheckCircle, ExternalLink, Home, ArrowLeft } from "lucide-react";
// import { Button } from "@/components/ui/button";

// export default function ThankYou() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { formData, whatsappUrl } = location.state || {};

//   useEffect(() => {
//     // If someone lands directly on this page without form submission
//     if (!formData) {
//       navigate("/");
//     }
//   }, [formData, navigate]);

//   if (!formData) {
//     return null;
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white flex items-center justify-center p-4">
//       <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl overflow-hidden">
//         {/* Success Header */}
//         <div className="bg-orange-600 p-6 text-center">
//           <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full mb-4">
//             <CheckCircle className="h-12 w-12 text-orange-600" />
//           </div>
//           <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">
//             Thank You for Your Request!
//           </h1>
//           <p className="text-orange-100">
//             Your consultation request has been successfully submitted
//           </p>
//         </div>

//         {/* Content */}
//         <div className="p-6 md:p-8">
//           <div className="mb-6">
//             <h2 className="text-lg font-semibold text-gray-800 mb-2">
//               What happens next?
//             </h2>
//             <div className="space-y-3 text-gray-600">
//               <p>✓ Our medical team will review your case within 24 hours</p>
//               <p>✓ You'll receive a personalized treatment plan via email/WhatsApp</p>
//               <p>✓ A coordinator will contact you to schedule a detailed consultation</p>
//             </div>
//           </div>

//           {/* WhatsApp Button */}
//           {whatsappUrl && (
//             <div className="mb-6 p-4 bg-green-50 rounded-lg border border-green-200">
//               <p className="text-sm text-green-800 mb-3">
//                 Connect with us instantly on WhatsApp:
//               </p>
//               <a
//                 href={whatsappUrl}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
//               >
//                 <ExternalLink className="h-4 w-4" />
//                 Open WhatsApp Chat
//               </a>
//             </div>
//           )}

//           {/* Submitted Info Summary */}
//           <div className="mb-6 p-4 bg-gray-50 rounded-lg">
//             <h3 className="font-semibold text-gray-700 mb-2">
//               Request Summary
//             </h3>
//             <div className="space-y-1 text-sm text-gray-600">
//               <p><span className="font-medium">Name:</span> {formData.name}</p>
//               <p><span className="font-medium">Email:</span> {formData.email}</p>
//               <p><span className="font-medium">Phone:</span> {formData.phone}</p>
//               <p><span className="font-medium">Country:</span> {formData.country}</p>
//               <p><span className="font-medium">Treatment:</span> {formData.treatment}</p>
//               {formData.message && (
//                 <p><span className="font-medium">Medical Details:</span> {formData.message}</p>
//               )}
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div className="flex flex-col sm:flex-row gap-3">
//             <Button
//               onClick={() => navigate("/")}
//               className="flex-1 bg-orange-600 hover:bg-orange-700 text-white"
//             >
//               <Home className="h-4 w-4 mr-2" />
//               Back to Home
//             </Button>
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outline"
//               className="flex-1"
//             >
//               <ArrowLeft className="h-4 w-4 mr-2" />
//               Go Back
//             </Button>
//           </div>s
//         </div>
//       </div>
//     </div>
//   );
// }


import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle, ExternalLink, Home, ArrowLeft, Calendar, Mail, Phone, MapPin, Activity, Clock, MessageCircle, Download, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ThankYou() {
    const location = useLocation();
    const navigate = useNavigate();
    const { formData, whatsappUrl } = location.state || {};

    useEffect(() => {
        // If someone lands directly on this page without form submission
        if (!formData) {
            navigate("/");
        }
    }, [formData, navigate]);

    if (!formData) {
        return null;
    }

    // Generate reference ID
    const referenceId = `MR${Date.now().toString(36).toUpperCase()}`;

    // Handle download summary
    const handleDownloadSummary = () => {
        const summary = `
Medical Tourism Consultation Request
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Reference ID: ${referenceId}
Date: ${new Date().toLocaleDateString()}
Time: ${new Date().toLocaleTimeString()}

Personal Information:
━━━━━━━━━━━━━━━━━━━━━
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Country: ${formData.country}
Treatment: ${formData.treatment}
${formData.message ? `Medical Details: ${formData.message}` : ''}

Next Steps:
━━━━━━━━━━
1. Our medical team will review your case within 24 hours
2. You'll receive a personalized treatment plan via email/WhatsApp
3. A coordinator will contact you to schedule a detailed consultation

Contact Information:
━━━━━━━━━━━━━━━━
Email: care@medicaltourism.com
Phone: +1 234 567 890
WhatsApp: +1 234 567 890

Thank you for choosing us!
    `;

        const blob = new Blob([summary], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `consultation-${referenceId}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    // Handle share
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Medical Tourism Consultation',
                    text: `I just requested a consultation for ${formData.treatment} treatment.`,
                    url: window.location.origin,
                });
            } catch (err) {
                console.log('Error sharing:', err);
            }
        } else {
            // Fallback - copy to clipboard
            navigator.clipboard.writeText(window.location.origin);
            alert('Link copied to clipboard!');
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
            {/* Confetti Animation Effect */}
            <div className="fixed inset-0 pointer-events-none overflow-hidden">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-yellow-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse delay-1000"></div>
            </div>

            <div className="relative max-w-4xl mx-auto px-4 py-8 md:py-12 lg:py-16">
                {/* Main Card */}
                <div className="bg-white rounded-3xl shadow-2xl overflow-hidden transform transition-all duration-500 hover:shadow-3xl">
                    {/* Success Header with Confetti Effect */}
                    <div className="relative bg-gradient-to-r from-orange-600 to-orange-500 p-8 md:p-10 text-center overflow-hidden">
                        <div className="absolute inset-0 opacity-10">
                            <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
                            <div className="absolute bottom-0 right-0 w-48 h-48 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
                        </div>

                        <div className="relative z-10">
                            <div className="inline-flex items-center justify-center w-24 h-24 bg-white rounded-full mb-6 animate-bounce">
                                <CheckCircle className="h-14 w-14 text-orange-600" />
                            </div>
                            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">
                                Thank You!
                            </h1>
                            <p className="text-orange-100 text-lg md:text-xl">
                                Your consultation request has been successfully submitted
                            </p>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="p-6 md:p-8 lg:p-10">
                        {/* What happens next - Timeline */}
                        <div className="mb-10">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                                <Calendar className="h-6 w-6 text-orange-600" />
                                What happens next?
                            </h2>
                            <div className="space-y-4">
                                {[
                                    { step: 1, title: "Case Review", desc: "Our medical team will review your case within 24 hours", icon: Clock, color: "blue" },
                                    { step: 2, title: "Treatment Plan", desc: "You'll receive a personalized treatment plan via email/WhatsApp", icon: Mail, color: "green" },
                                    { step: 3, title: "Consultation", desc: "A coordinator will contact you to schedule a detailed consultation", icon: Phone, color: "purple" }
                                ].map((item) => (
                                    <div key={item.step} className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl hover:shadow-md transition-shadow">
                                        <div className={`flex-shrink-0 w-10 h-10 rounded-full bg-${item.color}-100 flex items-center justify-center`}>
                                            <item.icon className={`h-5 w-5 text-${item.color}-600`} />
                                        </div>
                                        <div className="flex-1">
                                            <h3 className="font-semibold text-gray-800">Step {item.step}: {item.title}</h3>
                                            <p className="text-gray-600 text-sm">{item.desc}</p>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <div className="w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center">
                                                <span className="text-xs font-bold text-orange-600">{item.step}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* WhatsApp and Quick Actions */}
                        <div className="grid md:grid-cols-2 gap-6 mb-10">
                            {/* WhatsApp Card */}
                            {whatsappUrl && (
                                <div className="p-5 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border border-green-200">
                                    <div className="flex items-center gap-3 mb-3">
                                        <MessageCircle className="h-6 w-6 text-green-600" />
                                        <h3 className="font-semibold text-gray-800">Connect on WhatsApp</h3>
                                    </div>
                                    <p className="text-sm text-gray-600 mb-4">
                                        Get instant responses and faster communication
                                    </p>
                                    <a
                                        href={whatsappUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-5 rounded-lg transition-all transform hover:scale-105"
                                    >
                                        <ExternalLink className="h-4 w-4" />
                                        Start WhatsApp Chat
                                    </a>
                                </div>
                            )}

                            {/* Quick Actions */}
                            <div className="p-5 bg-gray-50 rounded-xl">
                                <h3 className="font-semibold text-gray-800 mb-3">
                                    Quick Actions
                                </h3>

                                <div className="space-y-2">

                                    {/* Download Summary */}
                                    <button
                                        onClick={handleDownloadSummary}
                                        className="w-full flex items-center gap-2 text-sm text-gray-700 hover:text-orange-600 transition-colors p-3 hover:bg-white rounded-lg border border-transparent hover:border-orange-100"
                                    >
                                        <Download className="h-4 w-4" />
                                        Download Summary
                                    </button>

                                    {/* Download Brochure PDF */}
                                    <a
                                        href="/Paxgrow-Brochure.pdf"
                                        download="Paxgrow-Brochure.pdf"
                                        className="w-full flex items-center gap-2 text-sm text-gray-700 hover:text-orange-600 transition-colors p-3 hover:bg-white rounded-lg border border-transparent hover:border-orange-100"
                                    >
                                        <Download className="h-4 w-4" />
                                        Download Brochure PDF
                                    </a>

                                    {/* Share Page */}
                                    <button
                                        onClick={handleShare}
                                        className="w-full flex items-center gap-2 text-sm text-gray-700 hover:text-orange-600 transition-colors p-3 hover:bg-white rounded-lg border border-transparent hover:border-orange-100"
                                    >
                                        <Share2 className="h-4 w-4" />
                                        Share This Page
                                    </button>

                                </div>
                            </div>
                        </div>

                        {/* Submitted Info Summary */}
                        <div className="mb-10 bg-gradient-to-r from-orange-50 to-yellow-50 rounded-xl p-6 border border-orange-100">
                            <h2 className="font-bold text-gray-800 mb-4 flex items-center gap-2">
                                Request Summary
                            </h2>
                            <div className="grid sm:grid-cols-2 gap-4">
                                <div className="space-y-3">
                                    <div className="flex items-center gap-2 text-sm">
                                        <span className="font-medium text-gray-700 w-24">Full Name:</span>
                                        <span className="text-gray-600">{formData.name}</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-sm">
                                        <Mail className="h-4 w-4 text-gray-400" />
                                        <span className="font-medium text-gray-700 w-24">Email:</span>
                                        <span className="text-gray-600">{formData.email}</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-sm">
                                        <Phone className="h-4 w-4 text-gray-400" />
                                        <span className="font-medium text-gray-700 w-24">Phone:</span>
                                        <span className="text-gray-600">{formData.phone}</span>
                                    </div>
                                </div>
                                <div className="space-y-3">
                                    <div className="flex items-center gap-2 text-sm">
                                        <MapPin className="h-4 w-4 text-gray-400" />
                                        <span className="font-medium text-gray-700 w-24">Country:</span>
                                        <span className="text-gray-600">{formData.country}</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-sm">
                                        <Activity className="h-4 w-4 text-gray-400" />
                                        <span className="font-medium text-gray-700 w-24">Treatment:</span>
                                        <span className="text-gray-600">{formData.treatment}</span>
                                    </div>
                                </div>
                                {formData.message && (
                                    <div className="sm:col-span-2 mt-2 pt-3 border-t border-orange-200">
                                        <p className="font-medium text-gray-700 text-sm mb-1">Medical Details:</p>
                                        <p className="text-gray-600 text-sm bg-white p-3 rounded-lg">{formData.message}</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4">
                            <Button
                                onClick={() => navigate("/")}
                                className="flex-1 bg-orange-600 hover:bg-orange-700 text-white h-12 text-base font-semibold shadow-md hover:shadow-xl transition-all"
                            >
                                <Home className="h-5 w-5 mr-2" />
                                Back to Home
                            </Button>
                            <Button
                                onClick={() => navigate(-1)}
                                variant="outline"
                                className="flex-1 h-12 text-base font-semibold border-2 hover:bg-gray-50 transition-all"
                            >
                                <ArrowLeft className="h-5 w-5 mr-2" />
                                Go Back
                            </Button>
                        </div>

                        {/* Footer Note */}
                        <div className="mt-8 text-center">
                            <p className="text-xs text-gray-400">
                                A confirmation email has been sent to your email address.
                                Please check your spam folder if you don't see it within 10 minutes.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}